export const department = {
  departmentData: 'Datos generales del departamento',
  "form": {
    "buttons": {
      "finish": "Finalizar"
    },
    "createTitle": "Creación y gestion de folios por departamento",
    "updateTitle": "Edición y gestion de folios por departamento",
    "crud": {
      "name": "Nombre del departamento",
      "departmentName": "El campo nombre del departamento es requerido",
      "title": "Datos generales del dpto.",
      "areaAssigned": "Área asignada"
    },
    "modal": {
      "deleteSettingsTitle": "¿Estás seguro que quieres desactivar la gestión de folios?",
      "deleteSettingsDescription": "se perderán las configuraciones realizadas",
      "deleteSettingsPermission_one": "¿Estás seguro que quieres eliminar el permiso seleccionado?",
      "deleteSettingsPermission_other": "¿Estás seguro que quieres eliminar los permisos seleccionados?",
      "deletePermissionDescription": "se perderán las configuraciones realizadas",
      "create": {
        "success": {
          "title": "El departamento se creó exitosamente",
          "description": ""
        },
        "errors": {
          "title": "Hubo un error y el departamento no puede ser creado"
        }
      },
      "edit": {
        "success": {
          "title": "El departamento se actualizó exitosamente",
          "description": ""
        },
        "errors": {
          "title": "Hubo un error y el departamento no puede ser actualizado"
        }
      }
    },
    "table": {
      "switch": "Gestiona folios",
      "allFolios": "Todos los folios",
      "reassingFolios": "Reasignar folios",
      "setting": "Configurar gestión de folios",
      delete: 'Eliminar permiso'
    },
    "tabs": {
      "title": "Seleccione los usuarios que desea asociar a este departamento",
      "titleFolio": "Configuración de permisos",
      "folio": "Folios",
      "settings": "Configuraciones",
      notified: 'Histórico de folios',
      reassignFolio: 'Reasignar Folios',
      hierarchy: 'Folios por jerarquía',
      "1": "AGREGAR USUARIOS",
      "2": "PERMISOS DE FOLIOS",
      "3": "DEPARTAMENTO",
    },
    "settings": {
      "title": "Configure la gestión de folios",
      "notificationsTitle": "Configure las notificaciones de folios",
      "user": "USUARIO",
      "accept": "Aceptar",
      "crud": {
        "user": "Seleccione los usuarios",
        "userType": "Seleccione los tipos de usuario",
        "store": "Seleccione las unidades"
      }
    }
  },
  "informationCard": {
    "checkUser": "Ver usuarios asociados",
    "create": "Nuevo departamento",
    "edit": "Editar departamento",
    "buttons": {
      "add": "Agregar departamento",
      "update": "Actualizar departamento",
      "cancel": "Cancelar",
      "edit": "Editar departamento"
    }
  },
  "modalTypeUser": {
    "associateUser": "Usuarios asociados",
    "searchUser": "Buscar usuario"
  },
  "snackbar": {
    "create": {
      "success": "El departamento se creó exitosamente",
      "error": "Ocurrió un error al crear el departamento"
    },
    "update": {
      "success": "El departamento se actualizó exitosamente",
      "error": "Ocurrió un error al actualizar el departamento"
    },
    "delete": {
      "success": "El departamento se eliminó exitosamente",
      "error": "Ocurrió un error al eliminar el departamento",
      "errorCode": {
        "ERR_DELETE_QUESTIONNAIRE_MAIN": "No se puede eliminar el departamento, porque se encuentra asociado a uno o más cuestionarios.",
        "ERR_DELETE_REPORT_FOLIO": "No se puede eliminar el departamento, porque se encuentra asociado a uno o más folios."
      }
    }
  },
  "modal": {
    "delete": {
      "title": "¿Está seguro que desea eliminar este departamento?",
      "description": "",
      "error": "Ocurrió un error al eliminar el departamento",
      "success": "La departamento se eliminó exitosamente"
    }
  }
}